var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgAudioDescription = function SvgAudioDescription(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 17",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 15,
    x: 0.94,
    y: 1,
    fill: "inherit",
    stroke: "currentColor",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.995 12.5H4.714l2.879-8h1.394l2.88 8h-1.282L8.323 5.953h-.062zm.215-3.133h4.156v1.016H6.21zm9.401 3.133h-2.59v-8h2.672q1.176 0 2.02.48.843.477 1.293 1.372.453.89.453 2.136 0 1.25-.457 2.149a3.2 3.2 0 0 1-1.312 1.383q-.86.48-2.079.48m-1.383-1.055h1.317q.915 0 1.52-.343.604-.348.906-1.004.3-.66.3-1.61 0-.941-.3-1.597a2.13 2.13 0 0 0-.887-.996q-.59-.34-1.465-.34h-1.39z"
  })));
};
export default SvgAudioDescription;